import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowUpComponent } from "./med-icon-arrow-up.component";

@NgModule({
  declarations: [
    MedIconArrowUpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowUpComponent,
  ],
})
export class MedIconArrowUpModule { }
